import { getDescendantCodes } from "@l2r-front/l2r-utils"

import { useRoadsideTypes } from "../queries/useRoadsideTypes"

export function useRoadsideDescendantCodes(code) {
    const { data: roadsideTypes } = useRoadsideTypes()

    return getDescendantCodes(code, roadsideTypes)
}